import SidePage from '@/shared/SidePage'
import SeparateLine from '@/shared/Forms/SeparateLine'
import equipmentUtils from '@/pages/Equipment/equipment.utils.ts'
import Button from '@/shared/Buttons/Button'
import DropdownListItem from '@/shared/Dropdowns/DropdownListItem'
import EquipmentFormFields from '@/pages/Equipment/components/SidePages/EquipmentFormFields'
import EquipmentPassportTree from '@/pages/Equipment/components/SidePages/EquipmentFormFields/EquipmentPassportTree'
import EquipmentPassportValuesForm from '@/pages/Equipment/components/SidePages/EquipmentFormFields/EquipmentPassportValuesForm'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import equipmentApi from '@/pages/Equipment/equipment.api.ts'
import equipmentEvents from '@/pages/Equipment/events/equipment/equipment.events.ts'
import useEquipmentForm from '@/pages/Equipment/components/SidePages/EquipmentFormFields/hooks/useEquipmentForm.ts'
import { TCreateEquipmentDTO } from '@/pages/Equipment/equipment.types.ts'

interface IProps {
  open: boolean
  onClose: (created?: boolean) => void
  initialState?: TCreateEquipmentDTO
}

const CreateEquipmentSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()

  const ctrl = useEquipmentForm({
    equipment: props.initialState || equipmentUtils.generateEmptyEquipment(),
    passport: { passportSchemaId: null, values: [] },
  })

  const handleCreate = () => {
    const job = async () => {
      const resp = await equipmentApi.createEquipment(ctrl.equipment)
      if (resp.status === 'success') {
        const passportResp = await equipmentApi.putEquipmentPassport(resp.body.id, ctrl.passport)
        if (passportResp.status === 'success') {
          return { ...resp, body: { ...resp.body, passportInstanceId: passportResp.body.id } }
        }
      }

      return resp
    }

    wait(job(), (resp) => {
      if (resp.status === 'success') {
        equipmentEvents.created(resp.body)
        props.onClose(true)
      }
    })
  }

  const renderContent = () => {
    if (ctrl.selectedTab === 'main') {
      return (
        <EquipmentFormFields
          equipment={ctrl.equipment}
          onChange={ctrl.handleEquipmentChange}
          passportSchemaId={ctrl.passport.passportSchemaId}
          onPassportSchemaChange={ctrl.handlePassportSchemaSelect}
        />
      )
    }
    if (ctrl.selectedTab === 'passport') {
      return (
        <EquipmentPassportValuesForm
          passportSchemaId={ctrl.passport.passportSchemaId}
          onChange={ctrl.handlePassportValueUpdate}
          values={ctrl.passport.values}
        />
      )
    }
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} size="large">
      <div className="flex-lines height100 gap16" style={{ scrollBehavior: 'smooth' }}>
        <h4 className="text-heading-4">Добавление устройства</h4>
        <SeparateLine />
        <div className="inline-flex-gap gap16 height100" style={{ minHeight: 0 }}>
          <div
            className="flex-lines gap8 height100"
            style={{
              width: '280px',
              borderRight: '1px solid var(--border-secondary-color)',
              paddingRight: '12px',
              minHeight: 0,
            }}
          >
            <DropdownListItem active={ctrl.selectedTab === 'main'} onClick={() => ctrl.handleTabSelect('main')}>
              <span className="text-nm" style={{ color: 'inherit' }}>
                Общие данные
              </span>
            </DropdownListItem>
            <SeparateLine />
            <span className="text-sm text-description" style={{ marginLeft: '12px' }}>
              Паспорт лифта
            </span>
            <EquipmentPassportTree
              passportSchemaId={ctrl.passport.passportSchemaId}
              selectCtrl={{ ...ctrl.groupSelectCtrl, handleSelect: ctrl.handlePassportGroupSelect } as any}
            />
          </div>
          <div
            className="flex-lines gap16 width100"
            style={{
              overflow: 'auto',
              paddingRight: '24px',
              height: '100%',
              minHeight: 0,
              paddingLeft: '2px',
              scrollBehavior: 'smooth',
            }}
          >
            {renderContent()}
          </div>
        </div>
        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap">
          <Button size="default" type="primary" text="Добавить" loading={loading} onClick={handleCreate} />
          <Button size="default" type="default" text="Отменить" disabled={loading} onClick={props.onClose} />
        </div>
      </div>
    </SidePage>
  )
}

export default CreateEquipmentSidePage
